let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b3INu")).then(() => parcelRequire('5bops'));